<div class='container'>
    <app-confirmation
    [view]="view"
    [detailMap]="detailMap"
    [makeModelYear]="makeModelYear"
    [appointment]="appointment">
    </app-confirmation>
</div>
